<template>
    <transition name="win-celebration-fade">
        <div
            v-if="visible"
            class="win-celebration"
            @click="dismiss"
        >
            <canvas ref="canvas" class="win-celebration__canvas"></canvas>
            <div class="win-celebration__content" @click.stop>
                <div class="win-celebration__badge">中奖啦</div>
                <div class="win-celebration__title">恭喜中奖</div>
                <div v-if="issueText" class="win-celebration__issue">期号 {{ issueText }}</div>
                <div v-if="profitText" class="win-celebration__profit">{{ profitText }}</div>
                <div class="win-celebration__hint">点击任意处关闭</div>
            </div>
        </div>
    </transition>
</template>

<script>
import FireworksEngine from '@/utils/fireworks';

const AUTO_HIDE_MS = 4800;

export default {
    name: 'WinCelebration',
    data() {
        return {
            visible: false,
            issueText: '',
            profitText: '',
            engine: null,
            hideTimer: null,
            resizeHandler: null,
        };
    },
    beforeDestroy() {
        this.cleanup();
    },
    methods: {
        play(payload = {}) {
            this.cleanup(false);
            this.issueText = payload.issue || '';
            this.profitText = payload.profitText || '';
            this.visible = true;

            this.$nextTick(() => {
                const canvas = this.$refs.canvas;
                if (!canvas) {
                    return;
                }
                this.engine = new FireworksEngine(canvas);
                this.engine.start(payload.duration || 4500);
                this.resizeHandler = () => {
                    if (this.engine) {
                        this.engine.resize();
                    }
                };
                window.addEventListener('resize', this.resizeHandler);
            });

            this.hideTimer = window.setTimeout(() => {
                this.dismiss();
            }, payload.duration || AUTO_HIDE_MS);
        },
        dismiss() {
            this.visible = false;
            this.cleanup();
        },
        cleanup(clearVisible = true) {
            if (clearVisible) {
                this.visible = false;
            }
            if (this.hideTimer) {
                window.clearTimeout(this.hideTimer);
                this.hideTimer = null;
            }
            if (this.resizeHandler) {
                window.removeEventListener('resize', this.resizeHandler);
                this.resizeHandler = null;
            }
            if (this.engine) {
                this.engine.stop();
                this.engine = null;
            }
        },
    },
};
</script>

<style scoped>
.win-celebration {
    position: fixed;
    inset: 0;
    z-index: 9999;
    overflow: hidden;
    background: rgba(8, 16, 40, 0.42);
    touch-action: none;
}

.win-celebration__canvas {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
}

.win-celebration__content {
    position: absolute;
    left: 50%;
    top: 42%;
    transform: translate(-50%, -50%);
    min-width: 220px;
    max-width: calc(100% - 48px);
    padding: 28px 24px 22px;
    border-radius: 18px;
    text-align: center;
    color: #fff;
    background: linear-gradient(145deg, rgba(255, 77, 79, 0.92), rgba(255, 169, 64, 0.92));
    box-shadow: 0 18px 48px rgba(255, 120, 48, 0.35);
    animation: win-pop 0.45s ease;
    pointer-events: none;
}

.win-celebration__badge {
    display: inline-block;
    margin-bottom: 10px;
    padding: 4px 12px;
    border-radius: 999px;
    font-size: 12px;
    letter-spacing: 2px;
    background: rgba(255, 255, 255, 0.22);
}

.win-celebration__title {
    font-size: 28px;
    font-weight: 700;
    letter-spacing: 2px;
}

.win-celebration__issue {
    margin-top: 8px;
    font-size: 13px;
    opacity: 0.92;
}

.win-celebration__profit {
    margin-top: 12px;
    font-size: 34px;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
}

.win-celebration__hint {
    margin-top: 14px;
    font-size: 12px;
    opacity: 0.82;
}

.win-celebration-fade-enter-active,
.win-celebration-fade-leave-active {
    transition: opacity 0.28s ease;
}

.win-celebration-fade-enter,
.win-celebration-fade-leave-to {
    opacity: 0;
}

@keyframes win-pop {
    0% {
        transform: translate(-50%, -50%) scale(0.72);
        opacity: 0;
    }

    100% {
        transform: translate(-50%, -50%) scale(1);
        opacity: 1;
    }
}
</style>
